import styled from 'styled-components';

export interface IInputProps {
    isNotValid?: boolean;
}

export const DecimalErrorWrapper = styled.div`
    display: flex;
    justify-content: right;
    justify-content: flex-end;
    color: #da4848;
    font-size: 0.9rem;
    font-weight: 500;
    text-align: right;
    margin-top: 5px;
`;

export const DecimalInputWrapper = styled.div<IInputProps>`
    display: flex;
    justify-content: right;
    font-size: 0.8rem;

    ${({ isNotValid }) =>
        isNotValid &&
        `
    border-left: 3px solid #a94442; /* red */
  `}

    ${({ isNotValid }) =>
        !isNotValid &&
        `
    border-left: 3px solid #25982e; /* green */
  `}
`;

export const DecimalInputOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
